<template>
    <section>

        <ContentLayer class="presentation background"
            v-if="currentPresentation.background"
            :content="presentation" :level="'presentation'" :layer="'background'"
            :structure="structure" :navigationData="navigationData" :active="active"
            :key="'chapter-' + chapter.uri + '-background'"/>

        <section class="presentation content fullscreen content-layer">
            <transition name="fade">
                <template v-for="(chapter, index) in presentation.chapters">
                    <Chapter class="chapter fullscreen"
                        v-if="index === currentChapterIndex"
                        :index="index"
                        :chapter="presentation.chapters[index]"
                        :settings="settings"
                        :navigationData="navigationData"
                        :structure="structure"
                        :presentationIndex="presentationIndex"
                        :chapterIndex="index"
                        :key="'chapter-' + chapter.uri" />
                </template>
            </transition>
        </section>

        <ContentLayer class="presentation background"
            v-if="currentPresentation.foreground"
            :content="presentation" :level="'presentation'" :layer="'foreground'"
            :structure="structure" :navigationData="navigationData" :active="active"
            :key="'chapter-' + chapter.uri + '-foreground'" />

    </section>
</template>

<script>

import Chapter from '@/core/components/Chapter'
import navigationMixin from '@/core/mixins/navigationMixin.js'

export default {
    data: () => {
        return {}
    },
    props: ['settings', 'presentation', 'presentationIndex', 'navigationData'],
    mixins: [navigationMixin],
    watch: {
        active(val) {
            if (val) this.onActivated
        }
    },
    computed: {
        active() {
            return this.presentationIndex === this.currentPresentationIndex
        }
    },
    methods: {
        onActivated() {
            if (!this.settings.disableNavigationDebugLogging) console.log("presentation: ", this.presentation.uri)
        },
        initializePresentation() {
            this.$el.style.backgroundColor = this.settings.presentationBackgroundColor
        }
    },
    components: {
        Chapter
    },
    created() {},
    mounted() {
        if (this.active) this.onActivated()
        this.initializePresentation()
    }
}
</script>

<style scoped lang="scss">

    @import '~@/core/assets/scss/_variables.scss';

    .presentation.background {
        z-index: 0;
    }

    .presentation.content {
        z-index: 1;

        .chapter {
            overflow: hidden;
        }
    }

    .presentation.foreground {
        z-index: 2;
        pointer-events: none;
    }

</style>
